
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 29 14","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.78 9.586c-.055-.838-.211-1.328-.444-1.982-.776-2.175-2.876-3.024-4.81-3.47-.013-.005-.022-.015-.035-.018-.147-.035-.292-.05-.438-.08a39.21 39.21 0 00-1.297-.24l-.02-.003c-.755-.656-4.173-3.456-7.82-3.72-1.73-.124-3.608-.091-5.966.11-1.709.145-3.645.31-5.198 1.687C1.098 3.335.098 5.305.009 7.276c-.14 3.09 1.422 4.015 1.986 4.25.455.928 1.326 1.565 2.337 1.565.987 0 1.841-.607 2.306-1.499h14.134c.465.892 1.319 1.499 2.305 1.499.95 0 1.78-.56 2.255-1.395h.02c.707 0 2.066-.053 2.99-.421.556-.213.508-.819.438-1.69zM4.332 11.592c-.738 0-1.339-.672-1.339-1.499 0-.826.601-1.498 1.34-1.498.737 0 1.338.672 1.338 1.498 0 .827-.6 1.5-1.339 1.5zm18.745 0c-.738 0-1.339-.672-1.339-1.499 0-.826.601-1.498 1.34-1.498.738 0 1.338.672 1.338 1.498 0 .184-.04.356-.093.518-.013.027-.016.06-.026.089-.209.524-.675.892-1.22.892zm2.67-1.404c0-.032.008-.062.008-.095 0-1.652-1.2-2.997-2.678-2.997-1.476 0-2.677 1.345-2.677 2.997H7.01c0-1.652-1.2-2.997-2.678-2.997-1.268 0-2.327.994-2.603 2.321-.237-.417-.428-1.055-.383-2.065.07-1.54.885-3.11 2.237-4.307C4.815 1.953 6.46 1.813 8.109 1.672c2.236-.193 4.052-.224 5.72-.104 2.004.145 3.99 1.202 5.369 2.12-.456-.001-.907.005-1.355.013-.811.01-1.632.026-2.474-.006l-.747-.025c-1.94-.062-3.947-.126-5.775-.649a3.648 3.648 0 01-.442-.152c-.349-.15-.733.046-.865.433-.131.387.042.82.387.966.193.082.39.148.589.205 1.972.564 4.055.631 6.067.696l.743.024c.864.03 1.705.018 2.534.006 1.672-.028 3.26-.032 4.896.298 1.793.356 3.734.974 4.336 2.663.215.603.313.93.357 1.593.004.05.013.14.02.24-.541.13-1.188.179-1.722.195z","fill":"#fff","fill-rule":"nonzero"}})])
          )
        }
      }
    